export const API_USER = "user";
export const API_NOTICE = "notice";
export const API_SETTLEMENT = "admin/settlement";
export const API_PV = "insight/pv";
export const API_PARTNER = "partner";
export const API_CONTENT = "insight/content";
export const API_REVENUE = "admin/revenue";
export const API_PROVIDER = "provider";
